export const havePremiumActive = (profile: any) => {
  return (
    profile?.groupSubscriptionActive ||
    profile?.groupSubscriptionPremiumGroupement ||
    profile?.groupSubscriptionPremiumPharmacy
  )
}
